<template>
  <div>
    <div v-show="!playerError" >
      <video  class="video-js" ref="videojs" autoplay controls>
        <source  :src="liveStream.url" type="application/x-mpegURL">
      </video>
    </div>
    <div v-show="playerError" >
      This live stream is not in progress at the moment, please confirm the live stream date and time.
    </div>
    <div v-if="liveStream.url && liveStream.url.includes('m3u8')" class="player">
      <div class="vx-row">

        <div v-show="liveStream.includeChat" class="vx-col xs:w-full sm:w-full md:w-full lg:w-full xl:w-1/4">
          <VuePerfectScrollbar
            class="chat-content-scroll-area border border-solid border-grey-light"
            :settings="settings"
            ref="chatLogPS"
            style="max-height: 75vh;min-height: 75vh"
          >
            <div class="chat__log" ref="chatLog">
              <task-chat :userId="activeGroupId" v-if="activeGroupId" :chatData="chatData"></task-chat>
            </div>
          </VuePerfectScrollbar>
          <div class="chat__input flex p-4 bg-white">
            <vs-input
              class="flex-1"
              placeholder="Type a message"
              v-model="typedMessage"
              @keyup.enter="sendMsg"
            />
            <vs-button id="send-btn" v-if="typedMessage" radius class="bg-primary-gradient ml-4" type="filled" @click="sendMsg" icon-pack="feather" icon="icon-send"></vs-button>
          </div>
        </div>
      </div>
    </div>

    <div v-show="!onlyContent" class="fab_direction-up__three-items">
      <div class="float-btn-group">
        <button class="btn-float btn-triger school-primary_gradient glow-effect_primary" @click="openActions">
          <i class="icon feather icon-more-horizontal text-white" />
        </button>
        <div class="btn-list">
          <a class="btn-float dc_dark-purple description glow-effect_dark" @click="backToTopic">
            <span class="descriptiontext">{{ topicName }}</span>
            <i class="icon feather icon-arrow-up text-white"></i>
          </a>
          <a class="btn-float dc_dark-purple description glow-effect_dark" v-show="nextTask" @click="next">
            <span class="descriptiontext">NEXT</span>
            <i class="icon feather icon-arrow-right text-white" />
          </a>
          <a class="btn-float dc_dark-purple description glow-effect_dark" v-show="prevTask" @click="previous">
            <span class="descriptiontext">PREVIOUS</span>
            <i class="icon feather icon-arrow-left text-white" />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  // export
  import videojs from 'video.js';
  import streaming  from '@videojs/http-streaming'; 
  import { uuid } from 'vue-uuid';
  import TaskChat from './ContentComponents/TaskChat.vue'
  import VuePerfectScrollbar from "vue-perfect-scrollbar";
  import * as signalR from "@aspnet/signalr";

  export default {
    components: {
      TaskChat,
      VuePerfectScrollbar,
      videojs,
      streaming
    },
    data() {
      return {
        queue: [],
        uuid: "",
        logData: {},
        fabElement: null,
        liveStream: {},
        onlyContent : false,
        backgroundCardHeight: 0,
        backgroundCardWidth: 0,
        standaloneContentDto: {},
        selectedData: {},
        topicName: '',
        index: null,
        currentTask: null,
        nextTask: null,
        prevTask: null,
        navigateByChoice: false,
        isTeacher: false,
        chatData: [],
        settings: {
          maxScrollbarLength: 60,
          wheelSpeed: 0.7,
        },
        typedMessage: "",
        connection: null,
        activeGroupId: null,
        isInGroup: false,
        playerError: false,
        isUserPremium: false,
        onSuccessForUserCheck: false,
        startCourseTaskLog: false,
      };
    },
    methods: {
      backToTopic() {
        var self = this;
        self.navigateByChoice = false;
        if(self.selectedData.selectedTopic)
          self.$router.push({ name: 'BrowseContent', params: { selectedData: self.selectedData, navFromVideo: true } });
        else if(self.selectedData.selectedTopic && self.isTeacher)
          self.$router.push({ name: 'TeacherBrowseContent', params: { selectedData: self.selectedData, navFromVideo: true } });
        else
          self.$router.push({ name: 'StudentRoster' });
      },
      next() {
        var self = this;
        self.index += 1;

        var data = {
          selectedData: self.selectedData,
          standaloneContentDto: self.standaloneContentDto,
          index: self.index
        }

        localStorage.setItem("lastKnownTopic", JSON.stringify(data));

        if (self.nextTask) {
          self.closeActions();

          self.logData.logIdentifier = self.uuid;
          self.logData.fromTaskId = self.currentTask.id;
          self.logData.toTaskId = self.nextTask.id;
          self.enqueue("LiveStreamTask/EndLogEntry", self.logData);

          self.currentTask = self.nextTask;

          self.uuid = self.$uuid.v4();
          self.logData.taskId = self.currentTask.id;
          self.logData.logIdentifier = self.uuid;
          self.logData.toTaskId = null;

          self.nextTask = self.index + 1 <= self.standaloneContentDto.tasks.length ? self.standaloneContentDto.tasks[self.index + 1] : null;
          self.prevTask = self.standaloneContentDto.tasks[self.index - 1];

          self.logData.fromTaskId = (self.prevTask ? self.prevTask.id : null);

          if (self.currentTask.liveStream && self.currentTask.liveStream.id) {
            if(!self.isUserPremium  && !self.currentTask.isPremium)
            {
              self.navigateByChoice = false;
              self.liveStream = self.currentTask.liveStream;

              self.enqueue("LiveStreamTask/StartLogEntry", self.logData);
            }
            else if(self.$store.state.aclSubscription.status.includes("PremiumContent"))
            {
              self.navigateByChoice = false;
              self.liveStream = self.currentTask.liveStream;

              self.enqueue("LiveStreamTask/StartLogEntry", self.logData);
            }
            else
            {
              self.showPremiumContentPopup();
            }
          }
          else if (self.currentTask.video && self.currentTask.video.id) {
            self.navigateByChoice = true;
            self.$router.push({
              name: "VideoViewer",
              params: {
                index: self.index,
                standaloneContent: self.standaloneContentDto,
                selectedData: self.selectedData,
                fromTaskId: (self.prevTask ? self.prevTask.id : null)
              }
            });
          }
          else if (self.currentTask.document && self.currentTask.document.id) {
            self.navigateByChoice = true;
            self.$router.push({
              name: "DocumentViewer",
              params: {
                index: self.index,
                standaloneContent: self.standaloneContentDto,
                selectedData: self.selectedData,
                fromTaskId: (self.prevTask ? self.prevTask.id : null)
              }
            });
          }
          else if (self.currentTask.podcast && self.currentTask.podcast.id) {
            self.navigateByChoice = true;
            self.$router.push({
              name: "PodcastViewer",
              params: {
                index: self.index,
                standaloneContent: self.standaloneContentDto,
                selectedData: self.selectedData,
                fromTaskId: (self.prevTask ? self.prevTask.id : null)
              }
            });
          }
          else if (self.currentTask.videoChat && self.currentTask.videoChat.id) {
            self.navigateByChoice = true;
            self.$router.push({
              name: "VideoChatPage",
              params: {
                index: self.index,
                standaloneContent: self.standaloneContentDto,
                selectedData: self.selectedData,
                fromTaskId: (self.prevTask ? self.prevTask.id : null)
              }
            });
          }
          else if (self.currentTask.upload && self.currentTask.upload.id) {
            self.navigateByChoice = true;
            self.$router.push({
              name: "UploadViewer",
              params: {
                index: self.index,
                standaloneContent: self.standaloneContentDto,
                selectedData: self.selectedData,
                fromTaskId: (self.prevTask ? self.prevTask.id : null)
              }
            });
          }
          else if (self.currentTask.presentation && self.currentTask.presentation.id) {
            self.navigateByChoice = true;
            self.$router.push({
              name: "PresentationViewer",
              params: {
                index: self.index,
                standaloneContent: self.standaloneContentDto,
                selectedData: self.selectedData,
                fromTaskId: (self.prevTask ? self.prevTask.id : null)
              }
            });
          }
        }
      },
      previous() {
        var self = this;
        self.index = --self.index;

        var data = {
          selectedData: self.selectedData,
          standaloneContentDto: self.standaloneContentDto,
          index: self.index
        }

        localStorage.setItem("lastKnownTopic", JSON.stringify(data));

        if (self.prevTask) {
          self.closeActions();

          self.logData.logIdentifier = self.uuid;
          self.logData.fromTaskId = self.currentTask.id;
          self.logData.toTaskId = self.prevTask.id;
          self.enqueue("LiveStreamTask/EndLogEntry", self.logData);

          self.currentTask = self.prevTask;

          self.uuid = self.$uuid.v4();
          self.logData.taskId = self.currentTask.id;
          self.logData.logIdentifier = self.uuid;
          self.logData.toTaskId = null;

          self.nextTask = self.standaloneContentDto.tasks[self.index + 1];
          self.prevTask = self.index > 0 ? self.standaloneContentDto.tasks[self.index - 1] : null;

          self.logData.fromTaskId = (self.nextTask ? self.nextTask.id : null);

          if (self.currentTask.liveStream && self.currentTask.liveStream.id) {
            if(!self.isUserPremium  && !self.currentTask.isPremium)
            {
              self.navigateByChoice = false;
              self.liveStream = self.currentTask.liveStream;
              self.enqueue("LiveStreamTask/StartLogEntry", self.logData);
            }
            else if(self.$store.state.aclSubscription.status.includes("PremiumContent"))
            {
              self.navigateByChoice = false;
              self.liveStream = self.currentTask.liveStream;
              self.enqueue("LiveStreamTask/StartLogEntry", self.logData);
            }
            else
            {
              self.showPremiumContentPopup();
            }
          }
          else if (self.currentTask.video && self.currentTask.video.id) {
            self.navigateByChoice = true;
            self.$router.push({
              name: "VideoViewer",
              params: {
                index: self.index,
                standaloneContent: self.standaloneContentDto,
                selectedData: self.selectedData,
                fromTaskId: (self.nextTask ? self.nextTask.id : null)
              }
            });
          }
          else if (self.currentTask.document && self.currentTask.document.id) {
            self.navigateByChoice = true;
            self.$router.push({
              name: "DocumentViewer",
              params: {
                index: self.index,
                standaloneContent: self.standaloneContentDto,
                selectedData: self.selectedData,
                fromTaskId: (self.nextTask ? self.nextTask.id : null)
              }
            });
          }
          else if (self.currentTask.podcast && self.currentTask.podcast.id) {
            self.navigateByChoice = true;
            self.$router.push({
              name: "PodcastViewer",
              params: {
                index: self.index,
                standaloneContent: self.standaloneContentDto,
                selectedData: self.selectedData,
                fromTaskId: (self.nextTask ? self.nextTask.id : null)
              }
            });
          }
          else if (self.currentTask.videoChat && self.currentTask.videoChat.id) {
            self.navigateByChoice = true;
            self.$router.push({
              name: "VideoChatPage",
              params: {
                index: self.index,
                standaloneContent: self.standaloneContentDto,
                selectedData: self.selectedData,
                fromTaskId: (self.nextTask ? self.nextTask.id : null)
              }
            });
          }
          else if (self.currentTask.upload && self.currentTask.upload.id) {
            self.navigateByChoice = true;
            self.$router.push({
              name: "UploadViewer",
              params: {
                index: self.index,
                standaloneContent: self.standaloneContentDto,
                selectedData: self.selectedData,
                fromTaskId: (self.nextTask ? self.nextTask.id : null)
              }
            });
          }
          else if (self.currentTask.presentation && self.currentTask.presentation.id) {
            self.navigateByChoice = true;
            self.$router.push({
              name: "PresentationViewer",
              params: {
                index: self.index,
                standaloneContent: self.standaloneContentDto,
                selectedData: self.selectedData,
                fromTaskId: (self.nextTask ? self.nextTask.id : null)
              }
            });
          }
        }
      },
      resizeCard() {
        this.backgroundCardWidth = window.innerWidth * 0.916;
        this.backgroundCardHeight = window.innerHeight * 0.755;

        if (this.vimeoPlayer) {
          this.vimeoPlayer.element.height = this.backgroundCardHeight;
          this.vimeoPlayer.element.width = this.backgroundCardWidth;
        }
      },
      openActions(e) {
        this.fabElement = e.target.closest(".float-btn-group");
        if (this.fabElement) {
          this.fabElement.classList.toggle('open')
        }
      },
      closeActions() {
        if (this.fabElement) {
          this.fabElement.classList.remove('open')
        }
      },
      showLoadingOnElement(element, scale, type) {
        var self = this;
        self.$vs.loading({
          type: type,
          container: self.$refs[element].$el,
          scale: scale
        });
      },
      enqueue(messageType, logPayload) {
        this.queue.push({
          type: messageType,
          payload: {
            logIdentifier: logPayload.logIdentifier.toString(),
            toTaskId: logPayload.toTaskId,
            fromTaskId: logPayload.fromTaskId,
            taskId: logPayload.taskId,
          }
        })
      },
      dequeue() {
        return this.queue.shift();
      },
      startProcessor() {
        var self = this;
        var onSuccess = function (response) {
          var next = self.dequeue();
          if (next)
            self.process(next, onSuccess);
        };
        setInterval(function () {
          if (self.queue.length > 0) {
            self.process(self.dequeue(), onSuccess)
          }
        }, 3000)
      },
      process(queueItem, successFunc) {
        var self = this;
        if (queueItem) {
          self.$ajaxPost(self, queueItem.type, queueItem.payload, function (response) {
            successFunc();
          });
        }
      },
      initChat() {
        var self = this;

        self.connection = new signalR.HubConnectionBuilder()
          .withUrl(`${self.$VUE_APP_SIGNALR}`)
          // .withAutomaticReconnect()
          .build();

        self.connection.start()
        .then(function(x) {
          self.connection.invoke("AddToGroup", self.activeGroupId).catch(function(err) {
            return console.error(err.toString());
          });
        })
        .catch(function(err) {
          return console.error(err.toString());
        });

        self.connection.on("Send", (userId, displayName, data, group) => {
          // const insertdata = { name: user, message: data };
          var isSameUser = userId == localStorage.getItem('Current_User_Id');
          var msg = {
            'sender': isSameUser ? '' : `${displayName}`,
            'textContent': data,
            'time': String(new Date()),
            'isSent': isSameUser,
            'isSeen': false,
            'senderId': userId
          };
          const insertdata = { name: self.liveStream.title, msg: msg, isPinned: false, id: self.activeGroupId };
          self.chatData.push(insertdata);
        });

        self.loadGroupMessages();
      },
      sendMsg() {
        var self = this;
        if (!self.typedMessage) return;

        if (self.connection && self.connection.state === signalR.HubConnectionState.Connected) {
          self.connection.invoke("SendMessage", localStorage.getItem('Current_User_Id'), JSON.parse(localStorage.getItem('userInfo')).displayName, self.typedMessage, self.activeGroupId, self.isInGroup);
          self.typedMessage = "";

          self.$refs.chatLogPS.$el.scrollTop = self.$refs.chatLog.scrollHeight;
        }
        else {
          self.$vs.dialog({
            type: "confirm",
            color: 'success',
            title: 'You are not connected',
            text: 'It seems that you have been disconnected from the Chat Server.\n\nClick the button below to reconnect...',
            accept: self.reloadPage,
            cancel: self.reloadPage,
            acceptText: "Reconnect!",
          })
        }
      },
      loadGroupMessages() {
        var self = this;
        // self.showLoadingOnElement("chat_list_sidebar", 1, "material");

        var onSuccess = response => {
          var isSameUser = null;
          self.isInGroup = response.data.isInGroup;

          response.data.messageDetails.forEach(function(item) {
            isSameUser = item.userId == localStorage.getItem('Current_User_Id');

            var msg = {
              'sender': isSameUser ? '' : `${item.userName}`,
              'textContent': item.messageText,
              'time': item.date,
              'isSent': isSameUser,
              'isSeen': false,
              'senderId': item.userId
            };
            const insertdata = { name: "name", msg: msg, isPinned: false, id: item.chatGroupId };
            self.chatData.push(insertdata);
          });

          
        };
        var onFinally = response => {
          // self.$vs.loading.close(self.$refs.chat_list_sidebar.$el);
        };

        self.$ajaxGet(self, "ChatMessage/GetMessagesByChatGroup?chatGroupId=" + self.activeGroupId, onSuccess, onFinally);
      },
      getIsUserPremium(onComplete){
        var self = this;
        var onSuccess = function(response){
          if(response.data){
            self.activeSubscription = response.data != null ? response.data : 0;
            self.isUserPremium = response.data.isUserPremium;
          }
          onComplete();
        }
        self.$ajaxGet(self, "public/getactivesubscription" , onSuccess);
      },
      showPremiumContentPopup() {
        var self = this;
        self.$swal({
          title: 'Cannot Continue',
          icon: 'warning',
          backdrop: true,
          allowOutsideClick: false,
          showCancelButton: true,
          confirmButtonText: 'Subscribe',
          html: `This is a premium task. <br> To access this content you have to be a <strong>premium subscriber</strong>.`,
          customClass: {
            confirmButton: 'vs-component vs-button vs-button-primary vs-button-filled mr-3',
            cancelButton: 'vs-component vs-button vs-button-warning vs-button-border ml-3',
          },
          showClass: {
            popup: 'animate__animated animate__tada',
          },
          buttonsStyling: false,
        }).then((result) => {
          if (result.value) { // <-- if confirmed
            window.open("/subscriptions");
          }
          else{
            self.backToTopic();
          }
        });
      },
    },
    beforeDestroy() {
      var self = this;
      if(self.startCourseTaskLog){
        if (self.currentTask && !self.navigateByChoice) {
          self.logData.logIdentifier = self.uuid;
          self.logData.fromTaskId = self.currentTask.id;
          self.logData.taskId = self.currentTask.id;
          self.logData.toTaskId = null;
          self.enqueue("LiveStreamTask/EndLogEntry", self.logData);
        }
      }
    },
    mounted() {
      var onComplete = response => {
        this.$setColors();
        var self = this;
        self.$store.dispatch("updateTheme", "dark");
        self.startProcessor();
        self.resizeCard();
        self.$nextTick(() => {
          window.addEventListener('resize', () => {
            self.resizeCard();
          });
        });

        self.isTeacher = localStorage.getItem("isTeacher");
        self.isTeacher = self.isTeacher == "true" ? true : false;

        var isStudentLocal = localStorage.getItem("isStudent");
        isStudentLocal = isStudentLocal == "true" ? true : false;

        if (Object.keys(self.$route.query).length != 0 && Object.keys(this.$route.params).length == 0) {
          if(self.$route.query.id){
            if(!localStorage.getItem("userInfo")) {
              document.cookie = "autoRedirect="+ JSON.stringify({url: "LiveStreamViewer", id: self.$route.query.id});
              window.location.replace("/login");
            }

              var success = (res) => {
                self.onlyContent = true;
                self.liveStream = {};  
                self.liveStream = res.data;
                self.uuid = self.$uuid.v4();

                self.logData.taskId = self.$route.query.id;
                localStorage.setItem("tid", self.$route.query.id);
                self.logData.logIdentifier = self.uuid;
                self.logData.toTaskId = null;
                self.logData.fromTaskId = self.$route.params.fromTaskId ? self.$route.params.fromTaskId : null;

                if (self.liveStream.includeChat) {
                  self.activeGroupId = self.liveStream.chatGroupId;
                  self.initChat();
                }
                var player = videojs(self.$refs.videojs);
              player.on('error', function() {  
              if(!self.liveStream.url.includes("stream.digitv.co.za") && ( player.error().code == 2 || player.error().code == 4) && !self.liveStream.url.includes(".mp4")){
                setTimeout(function(){
                self.liveStream.url = self.liveStream.url.replace(regEx, replaceMask);
                player.src({ type: "video/mp4", src: self.liveStream.url});
              
                player.play();

                },1000)

              } else if (self.liveStream.url.includes("stream.digitv.co.za") && ( player.error().code == 2 || player.error().code == 4)) {
                self.playerError = true;
                  setTimeout(function(){
                    self.playerError = false;
                    player.src({ type: "application/x-mpegURL", src: self.liveStream.url });
                    player.play();
                  },10000);						
              }
            });
              player.src({ type: "application/x-mpegURL", src: self.liveStream.url });

              };

            try{
              self.$ajaxGet(self, "LiveStreamTask/GetLiveStream/" + self.$route.query.id, success);
            } catch{} 
          }
        }
        else {
          if (Object.keys(this.$route.params).length != 0) {
            self.index = self.$route.params.index;

            self.currentTask = self.$route.params.standaloneContent.tasks.filter(function(item) { return item.index == self.index })[0];

            self.liveStream = self.$route.params.standaloneContent.tasks.filter(function(item) { return item.index == self.index })[0].liveStream;

            if (self.$route.params.standaloneContent.tasks.length > self.index + 1)
              self.nextTask = self.$route.params.standaloneContent.tasks.filter(function(item) { return item.index == (self.index + 1) })[0];

            if (self.index > 0)
              self.prevTask = self.$route.params.standaloneContent.tasks.filter(function(item) { return item.index == (self.index - 1) })[0];

            self.standaloneContentDto = self.$route.params.standaloneContent;
            
            if(self.$route.params.selectedData)
              self.selectedData = self.$route.params.selectedData;

            var data = {
              selectedData: self.selectedData,
              standaloneContentDto: self.standaloneContentDto,
              index: self.index
            }

            localStorage.setItem("lastKnownTopic", JSON.stringify(data));

            if(self.selectedData.selectedTopic)
              self.topicName = self.selectedData.selectedTopic.name;
            else
              self.topicName = "Back to My Roster";

            
            if(!self.isUserPremium  && !self.currentTask.isPremium)
            {
              self.uuid = self.$uuid.v4();
              self.logData.taskId = self.currentTask.id;
              localStorage.setItem("tid", self.currentTask.id);
              self.logData.logIdentifier = self.uuid;
              self.logData.toTaskId = null;
              self.logData.fromTaskId = self.$route.params.fromTaskId ? self.$route.params.fromTaskId : null;
              self.enqueue("LiveStreamTask/StartLogEntry", self.logData);

              if (self.liveStream.includeChat) {
                self.activeGroupId = self.liveStream.chatGroupId;
                self.initChat();
              }

              var player = videojs(self.$refs.videojs);
              player.on('error', function() {  
              if(!self.liveStream.url.includes("stream.digitv.co.za") && ( player.error().code == 2 || player.error().code == 4) && !self.liveStream.url.includes(".mp4")){
                setTimeout(function(){
                self.liveStream.url = self.liveStream.url.replace(regEx, replaceMask);
                player.src({ type: "video/mp4", src: self.liveStream.url});
                player.play();
                },1000)
              } else if (self.liveStream.url.includes("stream.digitv.co.za") && ( player.error().code == 2 || player.error().code == 4)) {
                self.playerError = true;
                  setTimeout(function(){
                    self.playerError = false;
                    player.src({ type: "application/x-mpegURL", src: self.liveStream.url });
                    player.play();
                  },10000);					
              }
            });
              player.src({ type: "application/x-mpegURL", src: self.liveStream.url });
            }
            else if(self.$store.state.aclSubscription.status.includes("PremiumContent")){
              self.uuid = self.$uuid.v4();
              self.logData.taskId = self.currentTask.id;
              localStorage.setItem("tid", self.currentTask.id);
              self.logData.logIdentifier = self.uuid;
              self.logData.toTaskId = null;
              self.logData.fromTaskId = self.$route.params.fromTaskId ? self.$route.params.fromTaskId : null;
              self.enqueue("LiveStreamTask/StartLogEntry", self.logData);

              if (self.liveStream.includeChat) {
                self.activeGroupId = self.liveStream.chatGroupId;
                self.initChat();
              }

              var player = videojs(self.$refs.videojs);
              player.on('error', function() {  
              if(!self.liveStream.url.includes("stream.digitv.co.za") && ( player.error().code == 2 || player.error().code == 4) && !self.liveStream.url.includes(".mp4")){
                setTimeout(function(){
                self.liveStream.url = self.liveStream.url.replace(regEx, replaceMask);
                player.src({ type: "video/mp4", src: self.liveStream.url});
                player.play();
                },1000)
              } else if (self.liveStream.url.includes("stream.digitv.co.za") && ( player.error().code == 2 || player.error().code == 4)) {
                self.playerError = true;
                  setTimeout(function(){
                    self.playerError = false;
                    player.src({ type: "application/x-mpegURL", src: self.liveStream.url });
                    player.play();
                  },10000);					
                }
              });
              player.src({ type: "application/x-mpegURL", src: self.liveStream.url });
            }
            else{
              self.showPremiumContentPopup();
            }
          }
          else {
            if (isStudentLocal) {
              self.$router.push({ name: 'StudentRoster' });
            }
            else {
              self.$router.push({ name: 'BrowseContent' });
            }
          }
        }
      }
      this.getIsUserPremium(onComplete);
    }
  };
</script>

<style type="stylesheet">
@import "https://unpkg.com/video.js/dist/video-js.min.css";
</style>

<style lang="scss">
  @import "@/assets/scss/vuesax/apps/chat.scss";

  .contentCards {
    margin: auto;
  }

  .fab_direction-up__three-items {
    right: 70px;
    bottom: 4vh;
    z-index: 999;
    position: fixed;
  }
  
    .video-js{
    width:100% !important;
    height: 79vh;
  }

</style>
